import 'devextreme/dist/css/dx.common.css';
import './themes/generated/theme.base.css';
import './themes/generated/theme.additional.css';
import 'vue-toastification/dist/index.css'

import Vue from "vue";
import App from "./App";
import router from "./router";
import appInfo from "./app-info";
import store from './store'
import i18n from './i18n'

import Toast from 'vue-toastification'
import VueLoading from 'vuejs-loading-plugin'
import VueGoodWizard from 'vue-good-wizard';

Vue.use(VueGoodWizard);
Vue.use(VueLoading, {
  dark: true,
  text: 'Loading...',
  loading: false,
  background: 'rgb(255,255,255)',
  classes: ['myclass']
});

Vue.use(Toast, {
  transition: "Vue-Toastification__fade",
  maxToasts: 20,
  newestOnTop: false,
  position: "top-right",
  timeout: 2000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: true,
  closeButton: "button",
  icon: true,
  rtl: false
});

Vue.config.productionTip = false;
Vue.prototype.$appInfo = appInfo;

// Set i18n instance in store
store.commit('SET_I18N', i18n)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");